import React from 'react';
import './OrderSeatSummary.scss';
import PriceItem from 'Components/Shared/PriceItem/PriceItem';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

interface IProps {
  totalPrice: number;
  setRef: (node: HTMLElement) => void;
}

const OrderSeatSummary: React.SFC<IProps> = ({
  totalPrice,
  setRef,
  children,
}) => (
  <div ref={ setRef } className='order-seat-summary'>
    <FormattedText 
      style='title black'
      displayName='Biljetter'
      formattedName='order.tickets.header'
    />
    { children }
    <div className='total-price bold'>
      <FormattedText
        displayName='Summa'
        formattedName='global.sum'
      />
      <PriceItem price={ totalPrice } decimals={ 2 } />
    </div>
  </div>
);

export const OrderSeatList: React.SFC<{}> = ({ children }) => (
  <table className='order-seat-list '>
    <tbody>
      { children }
    </tbody>
  </table>
);

export default OrderSeatSummary;


// WEBPACK FOOTER //
// ./src/components/OrderSeatSummary/OrderSeatSummary.tsx